import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from 'app/core/services/language.service';
import { AuthenticationService } from 'app/core/services/auth.service';
import { TokenService } from 'app/core/services/token.service';
import { TokenUser } from '@shared';
import { environment } from '@env/environment';
import { AdminNotificationState, AdminNotificationsService, SystemAdminService } from '@services';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  mode: string | undefined;
  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  _User!: TokenUser;
  _currentUser!: any;
  mainLogo = 'assets/images/logo/main_logo.png';
  isDevEnv = environment.isDevEnv;
  mainLogoSmall = 'assets/images/logo/main_logo_sm.png';
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(
    public _languageService: LanguageService,
    public _cookiesService: CookieService,
    private _authService: AuthenticationService,
    private _tokenService: TokenService,
    private _systemAdminService: SystemAdminService,
    private _toast: ToastrService,
    private _adminNotifications: AdminNotificationsService,
    private _translate: TranslateService,
  ) {
    this._adminNotifications.state$.subscribe((state) => (this.notificationState = state));
  }

  notificationState: AdminNotificationState = 'default';

  async enableNotifications() {
    if (this.notificationState === 'enabled') {
      this._toast.info(this._translate.instant('adminNotificationsOn.value'));
      return;
    }
    const state = await this._adminNotifications.enable();
    if (state === 'enabled') this._toast.success(this._translate.instant('adminNotificationsOn.value'));
    else if (state === 'denied') this._toast.warning(this._translate.instant('adminNotificationsBlocked.value'));
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Hebrew', flag: 'assets/images/flags/israel.jpg', lang: 'he' },
    { text: 'Arabic', flag: 'assets/images/flags/saudi_arab.png', lang: 'ar' },
  ];

  @Output() settingsButtonClicked = new EventEmitter();

  ngOnInit(): void {
    this.getLanguageFromCookies();
    this._tokenService.getCurrentUser().subscribe((data) => (this._currentUser = data));
  }

  getLanguageFromCookies() {
    this.cookieValue = this._cookiesService.get(environment.languageCookieKey);
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this._languageService.setLanguage(lang);
  }

  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    this._systemAdminService
      .updateAdmin(this._currentUser._id, { ...this._currentUser, lastSeen: new Date() })
      .subscribe({
        next: (response) => {
          if (response.status) {
            this._authService.logout();
          } else {
            this._toast.error(response.message);
          }
        },
        error: (error) => {
          this._toast.error(error);
        },
      });
  }
}
